























import Vue from 'vue'
import { AddImageStates } from '@/common/constants/imageUpload'

export default Vue.extend({
  methods: {
    backToUpload() {
      this.$emit('updateState', AddImageStates.IDLE)
    }
  }
})
